module.exports = __webpack_public_path__ + "static/media/stargold_7g.9ef11427.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/climasense/mosca_pinta/curativa/stargold_7g.png
// module id = 1276
// module chunks = 3